module.exports = __webpack_public_path__ + "static/media/crossIcon.87d8cd20.svg";